import React from 'react'
import { connect } from 'dva'

import appSelectors from 'models/app/selectors'
import scoreSelectors from 'models/score/selectors'
import questionSelectors from 'models/question/selectors'

import App from './App'

const checkIsAtLeastParameterZero = (score) => score
  .reduce((result, parameter) => result || parameter.score <= 0, false)

const AppContainer = ({ isGameStarted, score, currentResult, currentQuestion }) => {
  const isAtLeastParameterZero = checkIsAtLeastParameterZero(score)
  const isFailOutcomeDisplayed = isAtLeastParameterZero && !currentResult
  const isWinOutcomeDisplayed = !currentQuestion && !currentResult

  return <App
    isGameStarted={isGameStarted}
    isFailOutcomeDisplayed={isFailOutcomeDisplayed}
    isWinOutcomeDisplayed={isWinOutcomeDisplayed}
  />
}

function mapStateToProps(state, ownProps) {
  return Object.assign({},
    appSelectors(state, ownProps),
    scoreSelectors(state, ownProps),
    questionSelectors(state, ownProps),
  )
}

function mapDispatchToProps(dispatch) {
  return { }
}

export default connect(mapStateToProps, mapDispatchToProps)(AppContainer)



// WEBPACK FOOTER //
// ./src/components/App/index.js